import { isPlanup } from "../../Config"
import { hallColor } from "../../helpers/hall/index"
import { nameByType } from '../../services/quotation/item-type-name.js';
import { systemStatusKey } from './calendar-colors';
import store from '../../store'


function convertToUTCSameTime(localDate) {


    const utcDate = new Date(Date.UTC(localDate.getFullYear(), localDate.getMonth(), localDate.getDate(), localDate.getHours(), localDate.getMinutes(), localDate.getSeconds()));
    try {
        return utcDate.toISOString();
    } catch (e) {
        // console.log('error in convertToUTCSameTime, value was ', localDate);
        return '';
    }
    
}


function createGradient(colors) {
    const step = 100 / colors.length;
    const gradient = colors.map((color, index) => {
        const start = step * index;
        const end = step * (index + 1);
        return `${color} ${start}%, ${color} ${end}%`;
    }).join(', ');

    return `linear-gradient(to right, ${gradient})`;
}

// "דני כהן ורותי לוי" - the customer's contacts, for the pill's second line and the hover card
function contactNames(customer) {
    const contacts = customer && customer.contacts;
    if (!Array.isArray(contacts) || !contacts.length)
        return '';
    return contacts
        .map(contact => [contact.firstName, contact.lastName].filter(Boolean).join(' '))
        .filter(Boolean)
        .join(' ו');
}

function joinDetails(parts) {
    return parts.filter(Boolean).join(' · ');
}

function buildCrewMembersBackground(crewMembers) {

    if (!crewMembers)
        return '';

    let colors = crewMembers.map(itemCrewMember =>
        planup.$store.state.crewMembers.find(storeCrewMember => storeCrewMember.id == itemCrewMember.id)?.color
    )

    return `background: ${createGradient(colors)}`;

}


export const mapEvents = (x) => {

    if (!x.date)
        return;


    let classes = [];

    switch (x.planupSystemStatus) {

        case 'priceOfferSent':
        case 'pniaInTipul':
            classes.push('calendarItemMaybeEvent');
            break;

        case 'hazmanaSent':
            classes.push('calendarItemShiryunEvent');
            break;

        case 'hazmanaSigned':
            classes.push('calendarItemEvent');
            break;


        default:
            classes.push('calendarItemNewLead');
            break;



    }

    // צבעי לוח שנה (calendar-colors.js): the system status' color, the internal status' on top
    let colorClasses = ['pcSys_' + systemStatusKey(x.planupSystemStatus)];
    if (x.planupEventStatus && x.planupEventStatus.id)
        colorClasses.push('pcEventStatus_' + x.planupEventStatus.id);

    // Calculate end date based on event duration
    const startDate = convertToUTCSameTime(planup.$globals.addTimeToDate(new Date(x.date), x.time));
    let endDate = startDate;
    
    if (x.eventDurationDays && x.eventDurationDays > 1) {
        const endDateObj = new Date(x.date);
        endDateObj.setDate(endDateObj.getDate() + (x.eventDurationDays - 1));
        endDate = convertToUTCSameTime(planup.$globals.addTimeToDate(endDateObj, x.endTime || x.time));
    }


    return {
        'id': `event_${x.id}`,
        title: (x.time ? (x.time + ' ') : '') + (x.name ? x.name : 'ללא שם'),
        'startDate': startDate,
        'endDate': endDate,
        'classes': classes.concat(colorClasses),
        colorClasses: colorClasses,
        // 'style': 'background-color: #ddcff6;cursor:pointer',
        'itemType': 'event',
        'customer': x.customer,
        style: buildCrewMembersBackground(x.crewMembers),
        eventId: x.id,
        time: x.time,
        planupSystemStatus: x.planupSystemStatus,
        endTime: x.endTime,
        originalTitle: x.name,
        crewMembers: x?.crewMembers?.map(cm => cm.name).join(', '),
        place: x?.place?.name,
        // the pill's second line and the hover card (CalendarMonthGrid / CalendarHoverCard)
        eventClass: x.eventClass ? x.eventClass.name : '',
        guests: x.estimatedNumberOfGuests,
        eventStatusName: x.planupEventStatus ? x.planupEventStatus.name : '',
        customerName: contactNames(x.customer),
        subtitle: joinDetails([contactNames(x.customer), x.eventClass ? x.eventClass.name : '', x.place ? x.place.name : '']),
    }
}


// export const mapMaybeEvents = (x) => {

//     return {
//         'id': `maybeEvent_${x.id}`,
//         title: (x.time ? (x.time+' ') : '' ) + (x.name ? x.name : 'ללא שם'),
//         'startDate':  convertToUTCSameTime(planup.$globals.addTimeToDate(new Date(x.date),x.time)),
//         'classes': ['calendarItemMaybeEvent'],
//         // 'style': 'background-color: #ddcff6;cursor:pointer',
//         'itemType': 'maybeEvent',
//         'customer': x.customer,
//         eventId: x.id,
//         time: x.time,
//         endTime:x.endTime,
//         style: buildCrewMembersBackground(x.crewMembers),
//         originalTitle: x.name,
//     }
// }


export const mapGoogleEvents = (x) => {

    if (!x.date)
        return;

    return {
        title: x.name,
        startDate: new Date(x.date),
        'classes': ['calendarItemGoogleEvent'],
        // 'style': 'background-color: #ddcff6;cursor:pointer',
        'itemType': 'googleEvent',
        // 'customer': x.customer,
        // eventId: x.id,
        time: x.time,
        originalTitle: x.name,
    }
}


export const mapTasks = (x) => {

    if (!x.date)
        return;

    return {
        'id': `task_${x.id}`,
        title: x.name ? x.name : 'ללא שם',
        'startDate': convertToUTCSameTime(new Date(x.date)),
        'classes': ['calendarItemTask', 'pcTask'],
        colorClasses: ['pcTask'],
        // 'style': 'background-color: #17b3c7;cursor:pointer',
        'itemType': 'task',
        'customer': x.customer,
        taskId: x.id,
        time: x.time,
        endTime: x.endTime,
        style: buildCrewMembersBackground(x.crewMembers),
        originalTitle: x.name,
        crewMembers: x?.crewMembers?.map(cm => cm.name).join(', '),
        customerName: contactNames(x.customer),
        subtitle: contactNames(x.customer),
    }
}

export const mapQuotes = (x) => {

    return {
        'id': `quote_${x.id}`,
        'title': `${x.clientName} | ${nameByType(x.type)}`,
        'startDate': new Date(x.eventDate),
        'classes': ['x.type'],
        // 'style': isPlanup() ? 'background-color: #' + hallColor((x.hall.id * 10000).toString()).toString(16) : '',
        'itemType': 'quotation',
    }
}

// סטטוס הפגישה (התקיימה / הבריזו / בוטלה ...) of a meeting, from the store's list
function meetingStatusOf(meeting) {
    const id = meeting && meeting.meetingStatusId;
    const statuses = (store.state && store.state.planupMeetingStatuses) || [];
    return id ? statuses.find(status => status.id == id) || null : null;
}

export const mapMeetings = (x) => {

    if (!x.date)
        return;

    // צבעי לוח שנה (calendar-colors.js): the meeting color, the meeting type's on top
    let colorClasses = ['pcMeeting'];
    if (x.meetingType && x.meetingType.id)
        colorClasses.push('pcMeetingType_' + x.meetingType.id);

    // a meeting whose status says it does not take place is struck through; the status leads its
    // second line and the hover card
    const status = meetingStatusOf(x);
    if (status && status.cancelsMeeting)
        colorClasses.push('pcalMeetingOff');

    return {
        'id': `meeting_${x.id}`,
        title: (x.time ? (x.time + ' ') : '') + (x.title ? x.title : 'ללא שם'),
        'startDate': convertToUTCSameTime(planup.$globals.addTimeToDate(new Date(x.date), x.time)),
        'classes': ['calendarItemMeeting'].concat(colorClasses),
        colorClasses: colorClasses,
        'itemType': 'meeting',
        'customer': x.customer,
        meetingId: x.id,
        time: x.time,
        endTime: x.endTime,
        style: buildCrewMembersBackground(x.crewMembers),
        originalTitle: x.title,
        crewMembers: x?.crewMembers?.map(cm => cm.name).join(', '),
        place: x.place ? x.place.name : '',
        meetingType: x.meetingType ? x.meetingType.name : '',
        customerName: contactNames(x.customer),
        subtitle: joinDetails([status ? status.name : '', x.meetingType ? x.meetingType.name : '', contactNames(x.customer), x.place ? x.place.name : '']),
        meetingStatusName: status ? status.name : '',
    }
}

// שריון תאריך: one optional date of an undated event (calendar.controller holds) - an all-day
// item whose id carries the event id (hold_<eventId>_<day>), so clickItem opens the customer card.
// The day comes as 'YYYY-MM-DD' (already in Israel time); the title is escaped (v-html).
export const mapHolds = (x) => {

    if (!x || !x.day)
        return;

    const parts = String(x.day).split('-').map(Number);
    const day = new Date(parts[0], parts[1] - 1, parts[2], 0, 0, 0);
    const esc = s => String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    const who = x.contactNames || x.name || 'ללא שם';

    return {
        'id': `hold_${x.eventId}_${String(x.day).replace(/-/g, '')}`,
        'title': 'שריון: ' + esc(who),
        'startDate': convertToUTCSameTime(planup.$globals.addTimeToDate(day, null)),
        'classes': ['hold', 'calendarItemHold'],
        'colorClasses': [],
        'itemType': 'hold',
        eventId: x.eventId,
        customerId: x.customerId,
        customerName: who,
        originalTitle: who + (x.name ? ' - ' + x.name : ''),
        subtitle: 'תאריך אופציונלי' + (x.optionsCount > 1 ? ' (' + x.optionsCount + ' אפשרויות)' : '') + (x.holdUntil ? ', עד ' + x.holdUntil.split('-').reverse().join('/') : ''),
        eventClass: x.eventClass,
        place: x.place,
        guests: x.guests,
        planupSystemStatus: x.planupSystemStatus,
        time: null,
    }
}

// אישי (personal_item - calendar.controller personalItems): a user's block of time - מילואים, a
// doctor, a day off. Days come as 'YYYY-MM-DD' (no clock; endDate = the last day of a multi-day
// item), the time as 'HH:MM' or null (the whole day). The pill's second line is whose it is (when it
// is not mine) and the notes; clickItem opens PersonalItemModal on it.
export const mapPersonalItems = (x) => {

    if (!x || !x.date)
        return;

    const dayOf = text => {
        const parts = String(text).split('-').map(Number);
        return new Date(parts[0], parts[1] - 1, parts[2], 0, 0, 0);
    };

    const me = store.state && store.state.user ? store.state.user.id : null;
    const whose = x.userName && x.userId && (!me || x.userId != me) ? x.userName : '';
    const title = x.title || 'אישי';
    const startDate = convertToUTCSameTime(planup.$globals.addTimeToDate(dayOf(x.date), x.time));
    const endDate = x.endDate && x.endDate > x.date ? convertToUTCSameTime(planup.$globals.addTimeToDate(dayOf(x.endDate), x.endTime || x.time)) : startDate;

    // צבעי לוח שנה: the type's color, the user's on top (calendarColors.personalUser)
    const colorClasses = ['pcPersonal'];
    if (x.userId)
        colorClasses.push('pcPersonalUser_' + x.userId);

    return {
        'id': `personal_${x.id}`,
        title: (x.time ? (x.time + ' ') : '') + title,
        'startDate': startDate,
        'endDate': endDate,
        'classes': ['calendarItemPersonal'].concat(colorClasses),
        colorClasses: colorClasses,
        'itemType': 'personal',
        personalItemId: x.id,
        time: x.time || null,
        endTime: x.time ? (x.endTime || null) : null,
        originalTitle: title,
        userId: x.userId,
        userName: x.userName || '',
        notes: x.notes || '',
        blocksBooking: x.blocksBooking !== false,
        // a recurring item (a row of a series) - the hover card says how it repeats
        seriesId: x.seriesId || null,
        recurrenceText: x.recurrenceText || '',
        subtitle: joinDetails([whose, x.notes ? String(x.notes).split('\n')[0] : '']),
        allDay: !x.time,
    }
}

export const mapCalendarItems = (x) => {
    

    let prefix = x.type.replace('O', 'אופציה').replace('R', 'שריון').replace('N', '')
    return {
        'id': `item_${x.id}`,
        'title': `${prefix} - ${x.title}` || '',
        'startDate': new Date(x.start_date),
        'classes': [`item_${x.type}`],
        'itemType': `item_${x.type}`
    }
}